import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import axios from "axios";
import { queryParams } from "../../../../../utils/queryParams";

export const SET_LOADING = "./MEMBERSHIP_LENGTH/SET_LOADING";
export const FETCH_CURRENT_USER = "./MEMBERSHIP_LENGTH/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "./MEMBERSHIP_LENGTH/FETCH_CURRENT_USER_SUCCESS";
export const SET_UPDATES_LOADING = "./MEMBERSHIP_LENGTH/SET_UPDATES_LOADING";
export const FETCH_TABLE_SUCCESS = "./MEMBERSHIP_LENGTH/FETCH_TABLE_SUCCESS";
export const SET_TOGGLE = "./MEMBERSHIP_LENGTH/HANDLE_TOGGLE";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  handleToggle: createAction(SET_TOGGLE)
};

export default function* watchActiveMembers() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(SET_TOGGLE, fetchData);
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });

  yield put({ type: SET_LOADING, payload: true });

  try {
    yield fetchData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchData() {
  const [organization_id, location_id, object_id, region_id, date, former_memberships_only] =
    yield getCommonApiParams();

  const params = {
    organization_id,
    location_id,
    object_id,
    region_id,
    date,
    former_memberships_only
  };

  yield put({ type: SET_UPDATES_LOADING, payload: true });

  try {
    let { data: tableData } = yield call(
      axios.get,
      queryParams.apiVersion + "pages/memberships/membership_length",
      { params }
    );
    yield put({
      type: FETCH_TABLE_SUCCESS,
      payload: tableData
    });

    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

function* getCommonApiParams() {
  return yield select((state) => {
    const {
      formerMembershipsOnly,
      currentUser: { organizationId, locationId, objectId, regionId, calendarEndDate }
    } = state.membershipLength;

    if (!organizationId && !locationId && !objectId && !regionId && !calendarEndDate) return;

    return [organizationId, locationId, objectId, regionId, calendarEndDate, formerMembershipsOnly];
  });
}
